import '../styles/main.scss';

// import external dependencies
import $ from 'jquery';
import 'jquery-ui/ui/effect';

window.jQuery = window.$ = $;

import { library, dom } from '@fortawesome/fontawesome-svg-core';
import {
  faAngleDown,
  faArrowCircleRight,
  faChevronDown,
  faComments,
  faDownload,
  faFileAlt,
} from '@fortawesome/free-solid-svg-icons';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

import './dva-effects/effects/drawer';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
$(() => routes.loadEvents());

library.add(
  faAngleDown,
  faArrowCircleRight,
  faChevronDown,
  faComments,
  faDownload,
  faFileAlt,
);
dom.watch();

$('.toggle').click(function (e) {
  e.preventDefault();

  var $this = $(this);

  if ($this.next().hasClass('show')) {
    $this.next().removeClass('show');
    $this.next().slideUp('slow');
  } else {
    $this.parent().parent().find('div .inner').removeClass('show');
    $this.parent().parent().find('div .inner').slideUp('slow');
    $this.next().toggleClass('show');
    $this.next().slideToggle('slow');
  }
});
